// Copyright 2026 FlairCV Inc.
// SPDX-License-Identifier: LicenseRef-FlairCV-Enterprise

import { create } from 'zustand';

interface CreditState {
  balance: string;
  setBalance: (balance: string) => void;
}

/**
 * Credit store for displaying balance in the sidebar/header badge.
 * The source of truth is the server — this is a UI cache updated
 * after API responses.
 */
export const useCreditStore = create<CreditState>()((set) => ({
  balance: '0.00',
  setBalance: (balance) => set({ balance }),
}));
